import React, {useEffect, useMemo, useState} from 'react'
// import {KTSVG} from '../../../../_metronic/helpers'
// import Tooltip from 'react-bootstrap/Tooltip'
// import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import {RateInterpreterView} from './RateInterpreterView'
import {useQuery} from 'react-query'
import {
  getUserProfilePage,
  PROFILE_PAGE_QUERY_KEY,
  PROFILE_PAGE_STALE_MS,
} from './core/_requests'
import {ProfilePageProvider} from './ProfilePageContext'
import {useNavigate, useParams, useSearchParams} from 'react-router-dom'
import {useAuth} from '../../../modules/auth'
import {UserListEditInProfile} from './UserListEditInProfile'
import {InterpreterSettingsView} from './InterpreterSettingsView'
import LinguistNotesView from './LinguistNotesView'
import AdminConnectionTestTab from '../../connection-test/AdminConnectionTestTab'
import {RequesterSettings} from '../../customers-management/requester-settings/RequesterSettings'
import {MfaSettingsPanel} from './mfa/MfaSettingsPanel'
import InterpreterAiQcView from './InterpreterAiQcView'
import AdAstraSkillsAcademyView from './AdAstraSkillsAcademyView'

const DEFAULT_TAB = 1

function parseTabFromQuery(tabParam: string | null): number {
  if (!tabParam) return DEFAULT_TAB
  const n = parseInt(tabParam, 10)
  return Number.isFinite(n) && n > 0 ? n : DEFAULT_TAB
}

export function ConfigurationView() {
  let {id} = useParams()
  const {currentUser} = useAuth()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const tabFromUrl = useMemo(
    () => parseTabFromQuery(searchParams.get('tab')),
    [searchParams]
  )
  const [activeTab, setActiveTab] = useState(tabFromUrl)

  useEffect(() => {
    setActiveTab(tabFromUrl)
  }, [tabFromUrl])

  const handleTabClick = (tabNumber: number) => {
    setActiveTab(tabNumber)
    setSearchParams({tab: String(tabNumber)}, {replace: true})
  }

  const profilePageQuery = useQuery(
    [PROFILE_PAGE_QUERY_KEY, id],
    () => getUserProfilePage(id!),
    {
      staleTime: PROFILE_PAGE_STALE_MS,
      cacheTime: PROFILE_PAGE_STALE_MS,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: Boolean(id),
    }
  )

  const user = profilePageQuery.data?.account

  useEffect(() => {
    if (searchParams.get('mfa') !== '1') return
    const isOwnProfile = user?.code === currentUser?.result?.code
    if (!isOwnProfile || !user?.userType) return

    if (user.userType === 'INTERPRETER') {
      setActiveTab(9)
      setSearchParams({tab: '9'}, {replace: true})
    } else if (user.userType === 'SYSTEM' || user.userType === 'CONSUMER') {
      setActiveTab(7)
      setSearchParams({tab: '7'}, {replace: true})
    }
  }, [searchParams, user?.code, user?.userType, currentUser?.result?.code, setSearchParams])

  return (
    <ProfilePageProvider
      value={{
        data: profilePageQuery.data,
        isLoading: profilePageQuery.isLoading,
        isFetching: profilePageQuery.isFetching,
        refetch: profilePageQuery.refetch,
        error: profilePageQuery.error,
      }}
    >
      {/* <div className='mb-3'>
        <h1 className='mb-0 fw-semibold fs-2'>
          {user?.code === currentUser?.result?.code
            ? 'My Profile'
            : user?.userType === 'INTERPRETER'
            ? 'Interpreter'
            : user?.userType === 'CONSUMER'
            ? 'Requester'
            : user?.userType === 'SYSTEM'
            ? 'Admin'
            : 'Profile'}
        </h1>
        <span className='text-gray-500'>Manage Configuration</span>
      </div> */}
      <div className='mb-5'>
        <div className='d-flex align-items-center '>
          {user?.code !== currentUser?.result?.code && (
            <button
              className='btn btn-icon btn-bg-light btn-active-color-info btn-sm me-3'
              onClick={() => navigate(-1)}
            >
              <i className='bi bi-arrow-left-circle ' style={{fontSize: '28px'}}></i>
            </button>
          )}
          <div>
            <h1 className='mb-0 fw-bold mb-2' style={{fontSize: '25px', lineHeight: '32px'}}>
              {user?.code === currentUser?.result?.code
                ? 'My Profile'
                : user?.userType === 'INTERPRETER'
                ? 'Interpreter'
                : user?.userType === 'CONSUMER'
                ? 'Requester'
                : user?.userType === 'SYSTEM'
                ? 'Admin'
                : 'Profile'}
            </h1>
            <p className='text-gray-500 fs-5'>Manage Configuration</p>
          </div>
        </div>
      </div>
      <div className='card mb-5'>
        <div
          className='card-header py-0'
          style={{minWidth: '300px', overflowX: 'auto', minHeight: '50px'}}
        >
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-semibold flex-nowrap'>
            <li className='nav-item'>
              <a
                className={`nav-link fs-7 text-gray-400   ${
                  activeTab === 1 ? 'text-active-dark fw-bold active show' : ''
                }`}
                data-bs-toggle='tab'
                href='#kt_tab_pane_1'
                onClick={() => handleTabClick(1)}
              >
                Info
              </a>
            </li>

            {user?.userType == 'INTERPRETER' && (
              <li className='nav-item'>
                <a
                  className={`nav-link fs-7 text-gray-400 ${
                    activeTab === 2 ? 'text-active-dark fw-bold active show' : ''
                  }`}
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_2'
                  onClick={() => handleTabClick(2)}
                >
                  Rate
                </a>
              </li>
            )}

            {user?.userType == 'INTERPRETER' && (
            <li className='nav-item'>
              <a
                className={`nav-link fs-7 text-gray-400 ${
                  activeTab === 4 ? 'text-active-dark fw-bold active show' : ''
                }`}
                data-bs-toggle='tab'
                href='#kt_tab_pane_4'
                onClick={() => handleTabClick(4)}
              >
                Time Off
              </a>
            </li>
            )}
            {user?.userType == 'INTERPRETER' && currentUser?.result?.userType === 'SYSTEM' && (
            <li className='nav-item'>
              <a
                className={`nav-link fs-7 text-gray-400 ${
                  activeTab === 5 ? 'text-active-dark fw-bold active show' : ''
                }`}
                data-bs-toggle='tab'
                href='#kt_tab_pane_5'
                onClick={() => handleTabClick(5)}
              >
                Settings
              </a>
            </li>
            )}
            {user?.userType == 'INTERPRETER' && currentUser?.result?.userType === 'SYSTEM' && (
            <li className='nav-item'>
              <a
                className={`nav-link fs-7 text-gray-400 ${
                  activeTab === 6 ? 'text-active-dark fw-bold active show' : ''
                }`}
                data-bs-toggle='tab'
                href='#kt_tab_pane_6'
                onClick={() => handleTabClick(6)}
              >
                Notes
              </a>
            </li>
            )}
            {currentUser?.result?.userType === 'SYSTEM' && user?.userType !== 'INTERPRETER' && (
              <li className='nav-item'>
                <a
                  className={`nav-link fs-7 text-gray-400 ${
                    activeTab === 7 ? 'text-active-dark fw-bold active show' : ''
                  }`}
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_7'
                  onClick={() => handleTabClick(7)}
                >
                  Setting
                </a>
              </li>
            )}
            {user?.userType == 'INTERPRETER' && currentUser?.result?.userType === 'SYSTEM' && (
              <li className='nav-item'>
                <a
                  className={`nav-link fs-7 text-gray-400 ${
                    activeTab === 8 ? 'text-active-dark fw-bold active show' : ''
                  }`}
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_8'
                  onClick={() => handleTabClick(8)}
                >
                  Connection Test
                </a>
              </li>
            )}
            {user?.code === currentUser?.result?.code && user?.userType === 'INTERPRETER' && (
              <li className='nav-item'>
                <a
                  className={`nav-link fs-7 text-gray-400 ${
                    activeTab === 9 ? 'text-active-dark fw-bold active show' : ''
                  }`}
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_9'
                  onClick={() => handleTabClick(9)}
                >
                  Multi Factor Authentication
                </a>
              </li>
            )}
            {user?.code === currentUser?.result?.code && user?.userType === 'CONSUMER' && (
              <li className='nav-item'>
                <a
                  className={`nav-link fs-7 text-gray-400 ${
                    activeTab === 7 ? 'text-active-dark fw-bold active show' : ''
                  }`}
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_7'
                  onClick={() => handleTabClick(7)}
                >
                  Multi Factor Authentication
                </a>
              </li>
            )}
            {user?.userType == 'INTERPRETER' && currentUser?.result?.userType === 'SYSTEM' && (
              <li className='nav-item'>
                <a
                  className={`nav-link fs-7 text-gray-400 ${
                    activeTab === 9 ? 'text-active-dark fw-bold active show' : ''
                  }`}
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_9'
                  onClick={() => handleTabClick(9)}
                >
                  AI QC
                </a>
              </li>
            )}
            {user?.userType == 'INTERPRETER' && (
              <li className='nav-item'>
                <a
                  className={`nav-link fs-7 text-gray-400 ${
                    activeTab === 10 ? 'text-active-dark fw-bold active show' : ''
                  }`}
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_10'
                  onClick={() => handleTabClick(10)}
                >
                  AdAstra Skills Academy
                </a>
              </li>
            )}
            {/* <li className='nav-item'>
              <a
                className={`nav-link fs-7 text-gray-400 ${
                  activeTab === 3 ? 'text-active-dark fw-bold active show' : ''
                }`}
                data-bs-toggle='tab'
                href='#kt_tab_pane_3'
                onClick={() => handleTabClick(3)}
              >
                Authentication
              </a>
            </li> */}
          </ul>
        </div>
        <div className='card-body pt-0'>
          <div className=''>
            <div className='tab-content' id='myTabContent'>
              {activeTab === 1 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_1' role='tabpanel'>
                  <UserListEditInProfile
                    customerCode={Number(user?.fK_Customer) || 0}
                    userType={user?.userType ?? 'CONSUMER'}
                  />
                </div>
              )}

              {user?.userType == 'INTERPRETER' && activeTab === 2 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_2' role='tabpanel'>
                  <RateInterpreterView />
                </div>
              )}

              {user?.userType == 'INTERPRETER' && activeTab === 4 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_4' role='tabpanel'>
                  {(() => {
                    const TimeOffView = require('./TimeOffView').default
                    return <TimeOffView userId={id}
                    />
                  })()}
                </div>
              )}

              {user?.userType == 'INTERPRETER' && currentUser?.result?.userType === 'SYSTEM' && activeTab === 5 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_5' role='tabpanel'>
                  <InterpreterSettingsView userId={user?.code || id || ''} />
                </div>
              )}

              {user?.userType == 'INTERPRETER' && currentUser?.result?.userType === 'SYSTEM' && activeTab === 6 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_6' role='tabpanel'>
                  <LinguistNotesView linguistId={id} />
                </div>
              )}

              {currentUser?.result?.userType === 'SYSTEM' && user?.userType !== 'INTERPRETER' && activeTab === 7 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_7' role='tabpanel'>
                  {user?.userType === 'SYSTEM' && user?.code === currentUser?.result?.code ? (
                    <MfaSettingsPanel mode='self' />
                  ) : (
                    <RequesterSettings userId={id || ''} customerCode={user?.fK_Customer} />
                  )}
                </div>
              )}

              {user?.userType == 'INTERPRETER' && currentUser?.result?.userType === 'SYSTEM' && activeTab === 8 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_8' role='tabpanel'>
                  <AdminConnectionTestTab userId={id || ''} />
                </div>
              )}

              {user?.code === currentUser?.result?.code && user?.userType === 'INTERPRETER' && activeTab === 9 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_9' role='tabpanel'>
                  <MfaSettingsPanel mode='self' />
                </div>
              )}

              {user?.code === currentUser?.result?.code && user?.userType === 'CONSUMER' && activeTab === 7 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_7' role='tabpanel'>
                  <MfaSettingsPanel mode='self' />
                </div>
              )}

              {user?.userType == 'INTERPRETER' && currentUser?.result?.userType === 'SYSTEM' && activeTab === 9 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_9' role='tabpanel'>
                  <InterpreterAiQcView linguistId={id || ''} />
                </div>
              )}
              {user?.userType == 'INTERPRETER' && activeTab === 10 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_10' role='tabpanel'>
                  <AdAstraSkillsAcademyView linguistId={id || ''} />
                </div>
              )}
              {/* {activeTab === 3 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_3' role='tabpanel'>
                  <br />
                  <div
                    className='card mb-5 mb-xl-5 shadow-sm'
                    style={{borderTop: '3px solid #e3759b'}}
                  >
                    <div className='card-body pt-9 pb-4'>
                      <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                        <div className='flex-grow-1'>
                          <div className='d-flex justify-content-between align-items-start flex-wrap'>
                            <div className='d-flex flex-column'>
                              <div className='d-flex align-items-center'>
                                <div className='d-flex'>
                                  <h5 className='text-info fs-3 fw-bold '>
                                    IMPORTANT{' '}
                                    <i
                                      className='bi bi-info-circle-fill text-info me-2 '
                                      style={{fontSize: '1.3rem'}}
                                    >
                                      {' '}
                                    </i>
                                  </h5>
                                </div>
                              </div>

                              <div className='d-flex flex-wrap fs-6'>
                                <p className='text-gray-600' style={{fontSize: '12px'}}>
                                  We will ask you for a verification code upon initial login on any
                                  new device, and <br></br> then once every 30 days after that.
                                </p>
                              </div>
                              <div className='d-flex flex-wrap flex-sm-nowrap'>
                                <div className='pe-7 mb-4 border-2 border-end border-secondary'>
                                  <OverlayTrigger
                                    placement='top'
                                    overlay={<Tooltip id='tooltip-filter'> Email</Tooltip>}
                                  >
                                    <div>
                                      <button
                                        type='button'
                                        className='btn btn-primary btn-sm btn-icon'
                                        data-bs-toggle='modal'
                                        data-bs-target='#kt_modal_4'
                                      >
                                        <KTSVG
                                          path='/media/icons/duotune/communication/com002.svg'
                                          className='svg-icon-muted svg-icon-2'
                                        />
                                      </button>
                                    </div>
                                  </OverlayTrigger>
                                </div>

                                <div className='ps-0 ps-sm-7 flex-grow-1'>
                                  <div className='d-flex justify-content-between align-items-start flex-wrap'>
                                    <div className='d-flex flex-column'>
                                      <div className='d-flex align-items-center'>
                                        <span className='fs-6' style={{fontSize: '12px'}}>
                                          Sends a one-time verification code to your email address.{' '}
                                          <br></br> Email:
                                        </span>
                                      </div>

                                      <div className='d-flex flex-wrap fs-4'>
                                        <p className='text-black fw-bold'>OFF</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
            </div>
          </div>
          <img
            className='w-100 card-rounded-bottom'
            alt=''
            src='assetsmedia/svg/illustrations/bg-4.svg'
          />
        </div>
      </div>
    </ProfilePageProvider>
  )
}
